<template>
    <div class="mail-form" :class="{'disabled-inputs': disabled}">
        <v-card-text>
            <v-layout>
                <v-flex class="mail-form__header">
                    <div class="mail-form__header-row">
                        <div>Кому:</div>
                        <div><input required v-model="form.to"/></div>
                    </div>
                    <div class="mail-form__header-row">
                        <div>Копия:</div>
                        <div><input v-model="form.copy"/></div>
                    </div>
                    <div class="mail-form__header-row">
                        <div>Тема:</div>
                        <div><input required v-model="form.theme"/></div>
                    </div>
                </v-flex>
                <div style="display: flex; align-items: center">
                    <v-btn class="mail-form__send" color="blue darken-1" large flat @click.native="onSend">
                        <div>
                            <v-icon>send</v-icon>
                            <br>
                            <span>Отправить</span>
                        </div>
                    </v-btn>
                </div>
            </v-layout>

            <div class="mail-form__content">
                <interface-document :disabled="disabled" v-model="form.content" :options="{menubar: false}">
                    <slot name="content"></slot>
                </interface-document>
            </div>
        </v-card-text>

        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-text>Письмо успешно отправлено</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="dialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import InterfaceDocument from '@/components/interface/document'

    export default {
        props: {
            subject: String,
            to: String,
            copy: String,
            theme: String,
            content: String,
            disabled: Boolean
        },
        components: {
            InterfaceDocument
        },
        data() {
            return {
                dialog: false,
                form: {
                    subject: '',
                    content: '',
                    copy: '',
                    theme: '',
                    to: ''
                }
            }
        },
        methods: {
            onSend () {
                this.dialog = true
                this.$emit('submit', this.form)
            }
        },
        mounted () {
            this.form.subject = this.subject
            this.form.to = this.to
            this.form.copy = this.copy
            this.form.theme = this.theme
            this.form.content = this.content
        }
    }
</script>
<style lang="stylus" scoped>
    .mail-form {
        padding 18px
        background rgba(255, 187, 132, 0.14)

        &.disabled-inputs input {
            pointer-events none
        }

        &__header {
            &-row {
                display flex
                align-items center
                margin-bottom 12px

                & > div:first-child {
                    width 100px
                    text-align right
                    padding-right 15px
                }
                & > div:last-child {
                    flex 1 1
                }

                input {
                    background #fff
                    padding 10px
                    width 100%
                    box-sizing border-box
                    box-shadow inset 0 0 4px rgba(0, 0, 0, 0.3)
                }
            }
        }
        &__content {
            margin-top 30px
        }
        &__send {
            padding 12px 0
            height auto
        }
    }
    textarea {
        resize: none;
    }
</style>